import React from 'react';
import PropTypes from 'prop-types';

const PopupComponent = (props) => {
  return (
    <div className={`vfp-popup-wrapper ${props.popupClasses}`}>
      <div className="vfp-popup">
        {props.header && (
          <div className="popup-header">
            <h2>{props.header}</h2>
            {props.onClose && <i className='fa fa-close' onClick={props.onClose} />}
          </div>
        )}
        <div className="popup-body">
          {props.description && (<div className="popup-description">{props.description}</div>)}
          {props.children}
        </div>
        <div className="popup-footer">
          {props.buttons}
        </div>
      </div>
    </div>
  );
};

PopupComponent.propTypes = {
  header: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  buttons: PropTypes.node,
  popupClasses: PropTypes.string,
  onClose: PropTypes.func,
};

export default PopupComponent;